import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setSilent} from "../../../../redux/meta.js";
import {update} from "../../../app/setters/update.js";

export const useEdytujProfil = (setErrors) => {

    const queryClient = useQueryClient();
    const role = useSelector(state => state.user.role);
    const roleParam = role === 'oper' ? 'oper/' : '/';
    const navigate = useNavigate()
    const dispatch = useDispatch()
    return useMutation({
        mutationFn: (data) => update(`${roleParam}profile`, data),
        onError: (err) => {
            setErrors(err.response.data.errors);
            toast.error('Błąd podczas operacji')
        },

        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => {
                    const rootKey = query.queryKey?.[0]

                    return typeof rootKey === 'string' && (
                        rootKey.startsWith(`${role}_profile`) ||
                        rootKey.startsWith('profil__')
                    )
                },
            });
        },


        onSuccess: ({message, status}) => {
            dispatch(setSilent(true))
            navigate( role === 'oper' ? `/${role}/profile/lista` : '/')
            status === 'success' ? toast.success(message) : toast.error(message)
        },
    })
}